import React, { useReducer, createContext } from 'react';
import mockNotifications from '../tests/__mockData__/testNotificationsControls/mockNotificationsControlsv3.json';
/**
 * Context of the NotificationControls
 */
const NotificationControlsContext = createContext();

/**
 * This is the initial state
 */
let initialState = {
  mounted: false,
  submitting: false,
  isValid: false,
  notificationsAvailable: [],
  error: { isError: false, message: null },
  successfullChanges: false,
  controlsData: [],
  showError: false,
};

const emptyAmounts = (enabled = false) => ({
  high: enabled,
  medium: enabled,
  low: enabled,
});

/**
 * Ensures notifications.promotions[sportId] exists with a tournaments map.
 * Preferences from the API can omit promotions or individual sports.
 */
const ensureSportPromotion = (notifications, sportId) => {
  if (!notifications || typeof notifications !== 'object') {
    return null;
  }

  if (!notifications.promotions || typeof notifications.promotions !== 'object') {
    notifications.promotions = {};
  }

  const sportKey = String(sportId);
  if (!notifications.promotions[sportKey]) {
    notifications.promotions[sportKey] = {
      id: Number(sportId) || sportId,
      enabled: false,
      tournaments: {},
    };
  }

  if (
    !notifications.promotions[sportKey].tournaments ||
    typeof notifications.promotions[sportKey].tournaments !== 'object'
  ) {
    notifications.promotions[sportKey].tournaments = {};
  }

  return notifications.promotions[sportKey];
};

const ensureTournamentAmounts = (sportPromotion, tournamentId, amounts) => {
  const tournamentKey = String(tournamentId);
  if (!sportPromotion.tournaments[tournamentKey]) {
    sportPromotion.tournaments[tournamentKey] = {
      enabled: true,
      amounts: amounts || emptyAmounts(false),
      id: Number(tournamentId) || tournamentId,
    };
  } else if (!sportPromotion.tournaments[tournamentKey].amounts) {
    sportPromotion.tournaments[tournamentKey].amounts = amounts || emptyAmounts(false);
  }
  return sportPromotion.tournaments[tournamentKey];
};

/**
 * The reducer handles the state of the NotificationControls
 * @param { Object } state
 * @param { Object } action
 * @return newState
 */
const reducer = (state, action) => {
  let newNotifications = state.notificationsAvailable;
  // console.log( "reducing .",state);  
  switch (action.type) {
    case 'updateSportsList':
      return { ...state, sportsList: action.payload };
    case 'initializeTournaments':
      console.log(action.payload);
      newNotifications = mockNotifications.notifications;
      action.payload.forEach((sport) => {
        let torunamentsPerSport = {};
        sport.tournaments.forEach((sTour) => {
          if (
            newNotifications['promotions'][sport.id] &&
            newNotifications['promotions'][sport.id].enabled
          ) {
            let tournamentObj = { amounts: { high: true, medium: true, low: true } };
            torunamentsPerSport[sTour.id] = tournamentObj;
            newNotifications['promotions'][sport.id].tournaments[sTour.id] = tournamentObj;
          } else {
            console.error('sport not enabled', sport.name);
          }
        });
      });
      return { ...state, notificationsAvailable: newNotifications, sportsList: action.payload };
    case 'isReady':
      return { ...state, mounted: true };
    case 'resetData':
      return initialState;
    case 'changeSubmit':
      return { ...state, submitting: action.payload };
    case 'handleErrorWindow':
      return { ...state, showError: !state.showError };
    case 'updateNotifications':
      return { ...state, notificationsAvailable: action.payload };
    case 'updateSwitchData':
      newNotifications = { ...(state.notificationsAvailable || {}) };
      if (!newNotifications[action.payload.category]) {
        newNotifications[action.payload.category] = {};
      }
      newNotifications[action.payload.category] = {
        ...newNotifications[action.payload.category],
        [action.payload.name]: !newNotifications[action.payload.category][action.payload.name],
      };
      return { ...state, notificationsAvailable: newNotifications };

    case 'updateSportsNotifications': {
      newNotifications = { ...(state.notificationsAvailable || {}) };
      const sportPromotion = ensureSportPromotion(newNotifications, action.payload.value);
      if (!sportPromotion) {
        return state;
      }

      sportPromotion.enabled = !sportPromotion.enabled;
      const amountsEnabled = sportPromotion.enabled;

      (state.sportsList || []).forEach((sport) => {
        if (sport.id !== action.payload.value) {
          return;
        }
        (sport.tournaments || []).forEach((sportTournaments) => {
          ensureTournamentAmounts(sportPromotion, sportTournaments.id, emptyAmounts(amountsEnabled));
          sportPromotion.tournaments[String(sportTournaments.id)].amounts = emptyAmounts(
            amountsEnabled
          );
          sportPromotion.tournaments[String(sportTournaments.id)].enabled = amountsEnabled;
        });
      });

      return { ...state, notificationsAvailable: newNotifications };
    }
    case 'updateTournamentsNotifications': {
      newNotifications = { ...(state.notificationsAvailable || {}) };
      const sportPromotion = ensureSportPromotion(newNotifications, action.payload.sportId);
      if (!sportPromotion) {
        return state;
      }

      const tournament = ensureTournamentAmounts(
        sportPromotion,
        action.payload.tournamentId,
        emptyAmounts(false)
      );
      const { low, medium, high } = tournament.amounts;
      const allSelected = Boolean(low && medium && high);
      tournament.amounts = emptyAmounts(!allSelected);
      tournament.enabled = !allSelected;

      return { ...state, notificationsAvailable: newNotifications };
    }
    case 'updateEntryNotifications': {
      newNotifications = { ...(state.notificationsAvailable || {}) };
      const sportPromotion = ensureSportPromotion(newNotifications, action.payload.sportId);
      if (!sportPromotion) {
        return state;
      }

      const tournament = ensureTournamentAmounts(
        sportPromotion,
        action.payload.tournamentId,
        emptyAmounts(false)
      );
      const amountType = action.payload.amountType;
      if (!amountType) {
        return state;
      }

      tournament.amounts[amountType] = !tournament.amounts[amountType];

      return { ...state, notificationsAvailable: newNotifications };
    }
    case 'isError':
      return {
        ...state,
        submitting: false,
        error: { isError: action.payload.value, message: action.payload.message },
        mounted: true,
        showError: true,
      };
    case 'handleSuccessfullChanges':
      return {
        ...state,
        submitting: false,
        successfullChanges: !state.successfullChanges,
        error: { isError: false, message: null },
        mounted: true,
        showError: false,
      };
    case 'updateHandleAllAmoutPerSport': {
      newNotifications = { ...(state.notificationsAvailable || {}) };
      const sportPromotion = ensureSportPromotion(newNotifications, action.payload.sportId);
      if (!sportPromotion) {
        return state;
      }

      const amountType = action.payload.amountType;
      const sportFromList = (state.sportsList || []).find(
        (sport) => String(sport.id) === String(action.payload.sportId)
      );
      const tournamentIds = sportFromList
        ? (sportFromList.tournaments || []).map((tournament) => tournament.id)
        : Object.keys(sportPromotion.tournaments);

      tournamentIds.forEach((tournamentId) => {
        ensureTournamentAmounts(sportPromotion, tournamentId, emptyAmounts(false));
      });

      const allSelected =
        tournamentIds.length > 0 &&
        tournamentIds.every((tournamentId) => {
          const tournament = sportPromotion.tournaments[String(tournamentId)];
          return Boolean(tournament && tournament.amounts && tournament.amounts[amountType]);
        });

      tournamentIds.forEach((tournamentId) => {
        const tournament = sportPromotion.tournaments[String(tournamentId)];
        tournament.amounts[amountType] = !allSelected;
      });

      return { ...state, notificationsAvailable: newNotifications };
    }
    default:
      return { ...state };
  }
};

/**
 * The provider gives the let see and handles the state and dispatch
 * It also returns the childrens nested in the Provider
 * @param {Object} props
 */
const NotificationControlsContextProvider = (props) => {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = { state, dispatch };
  return (
    <NotificationControlsContext.Provider value={value}>
      {props.children}
    </NotificationControlsContext.Provider>
  );
};

const NotificationControlsContextConsumer = NotificationControlsContext.Consumer;

export {
  NotificationControlsContext,
  NotificationControlsContextProvider,
  NotificationControlsContextConsumer,
};
